<template>
    <div class="score-ruler">
        <div class="bar"></div>
        <div class="bar-pointer"></div>
    </div>
</template>
<style lang="scss" scoped>
.score-ruler {
    width: 150px;
    height: 5px;
    border-radius: 11px;
    background: rgba(228, 229, 232, 1);
    position: relative;
    .bar {
        width: 50%;
        height: 100%;
        border-radius: 11px;
        background-color: rgb(34, 64, 195);
    }
    .bar-pointer {
        width: 13px;
        height: 13px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
